import Environment from '../../environment';
import axios from 'axios';
import {onFulfilled} from './interceptors/request';
import {
  getLocalStorage,
  handleLogout,
  removeLocalStorage,
  setLocalStorage,
} from '@/Utils/CommonUtils';
import {useNavigation} from '@react-navigation/native';
import {ScreenName} from '@/navigators/StackConstants';

const ChessRestClient = axios.create({
  baseURL: Environment.CHESS_API_URL,
});
ChessRestClient.interceptors.request.use(onFulfilled);

ChessRestClient.interceptors.response.use(
  async response => {
    const currentVersion = await getLocalStorage('appVersion');
    const responseVersion = response.data.version;

    if (
      responseVersion &&
      currentVersion !== null &&
      currentVersion !== responseVersion
    ) {
      await setLocalStorage('appVersion', responseVersion);
      await removeLocalStorage('intuition-trainer-state');
      window.location.reload();
    }

    // If the request was successful, just forward the response
    return response;
  },
  error => {
    // If request was sent and server responded with a status outside of the 2xx range
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // Handle 401 error code.
          handleLogout(() => {
            window.location.href = '/login';
            // navigation?.navigate(ScreenName?.Login);
          });
          console.error('401 Unauthorized Error');
          break;
        case 403:
          // Resource-level "forbidden", not a session problem -- e.g. Player
          // Profile's Games/Training/Assessment tabs 403 for a viewer the
          // owner has locked out, with a perfectly valid token otherwise.
          // Forcing a logout here would kick a signed-in user to /login just
          // for viewing someone else's restricted tab. Let the caller's own
          // isError/catch handle it instead (only 401 means "your session
          // itself is invalid").
          console.error('403 Forbidden Error');
          break;
        default:
          break;
      }
    }
    return Promise.reject(error);
  },
);

export default ChessRestClient;
